module.exports = __webpack_public_path__ + "img/xz.b5c807fe.jpg";